'use strict';

var index = require('./index-7124f64c.js');

function getSystemPropTypes(system) {
  if (!system) return {};
  return system.meta.props.reduce(function (obj, prop) {
    obj[prop] = index.propTypes.oneOfType([index.propTypes.number, index.propTypes.string, index.propTypes.object, index.propTypes.bool]);
    return obj;
  }, {});
}

exports.getSystemPropTypes = getSystemPropTypes;
//# sourceMappingURL=xstyled-prop-types.es-4220f7f4.js.map
